import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DocumentOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DocumentOutlined({
  title = 'Document',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Document'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M3 1v22h18V1H3Zm15 19H6V4h12v16ZM16 6H8v3h8V6Zm-8 5h6v3H8v-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DocumentOutlined;